<script setup>
import { onMounted, computed, } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import moment from 'moment';

dayjs.extend(localizedFormat)

const parseTimelineToJSON = (string) => {
    if (!string) return '';
    const data = JSON.parse(string);

    let text = '';
    for (const key in data) {
       text += `<strong>${key.replaceAll("_", " ")}:</strong> ${data[key]}<br/>`;
    }
    return text;
}

const getTimelineDispute = () => store.dispatch('trafficRecordComponent/getTimelineDispute');

const timeline_dispute = computed(() => store.state.trafficRecordComponent.timeline_dispute);

onMounted(()=>{
    getTimelineDispute()
})

const store = useStore()

const loading = computed(() => store.state.globals.loading);

</script>

<template>
    <div class="col-md-12 col-lg-6 col-xl-4 mb-1">
        <b-overlay :show="loading">
            <div class="card">
                <div class="card-body overflow-auto">
                    <table class="table table-bordered table-sm table-light m-0">
                        <tbody>
                            <tr>
                                <th colspan="3" class="text-center">Dispute Details</th>
                            </tr>
                            <tr>
                                <th scope="col">Date</th>
                                <th scope="col" colspan="2">Details</th>
                            </tr>
                            <template v-if="timeline_dispute.length">
                                <tr v-for="(dispute, index) in timeline_dispute" :key="index">
                                    <td>{{ dispute.created_at ? moment(dispute.created_at).format('ddd, D MMM YYYY hh:mm:ss A') : '' }}</td>
                                    <td>
                                        <p class="text-muted mb-2 text-uppercase">
                                            {{ dispute.chapter }}
                                        </p>
                                        <p class="text-uppercase"
                                            v-html="parseTimelineToJSON((dispute.data))">
                                        </p>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="35" class="text-center ">No Dispute Record</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-overlay>
    </div>
</template>
